export default "__VITE_ASSET__63f984a4__"